import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withSnackbar } from 'notistack';

import {
  requestFeatureFlags,
  requestMWLinksLength,
  fetchMWLinks,
  setStories,
} from '~/thunks';

import { REQUEST_FEATURE_FLAGS_DEBOUNCE_TIMEOUT } from '~/constants';

import { setBrowserID } from '~/thunks/fingerprint';

import { LocalStorage } from '~/helpers';
import { getChatbotSettings, getIsAuthorized } from '~/selectors';

const origin = new URLSearchParams(document.URL).get('origin');

if (origin) {
  LocalStorage.setOrigin(origin);
} else {
  LocalStorage.removeOrigin();
}

const GlobalsProvider = ({ enqueueSnackbar, children }) => {
  const dispatch = useDispatch();
  const isAuthorized = useSelector(getIsAuthorized);
  const chatbotSettings = useSelector(getChatbotSettings);

  useEffect(() => {
    const requestFFInterval = setInterval(() => {
      if (!isAuthorized) {
        return;
      }

      dispatch(requestFeatureFlags());
    }, REQUEST_FEATURE_FLAGS_DEBOUNCE_TIMEOUT);

    const requestShortLinksLengthInterval = setInterval(() => {
      if (!isAuthorized) {
        return;
      }

      dispatch(requestMWLinksLength(enqueueSnackbar));
    }, 1000 * 60);

    return () => {
      clearInterval(requestFFInterval);
      clearInterval(requestShortLinksLengthInterval);
    };
  }, [dispatch, enqueueSnackbar, isAuthorized]);

  useEffect(() => {
    const fetchGlobalData = async () => {
      // fetch stories and short links only if authorized
      if (!isAuthorized) {
        return;
      }

      await dispatch(setStories({ enqueueSnackbar: () => {} }));
      await dispatch(fetchMWLinks(enqueueSnackbar));
      await dispatch(setBrowserID(enqueueSnackbar));
    };

    fetchGlobalData();
  }, [isAuthorized, chatbotSettings, dispatch, enqueueSnackbar]);

  return <>{children}</>;
};

export default withSnackbar(GlobalsProvider);
